<div neoDialogTitleContainer class="title-container">
  <h2 neoDialogTitle class="title" [attr.aut-id]="data.autIdPrefix + 'notification-detail-title'">{{ data.title }}</h2>
  <button
    type="button"
    class="close-icon"
    aria-label="Close"
    [attr.aut-id]="data.autIdPrefix + 'notification-detail-x-btn'"
    (click)="onClose()"
  >
    <span aria-hidden="true">×</span>
  </button>
</div>

<div neoDialogContent class="dialog-content">
  <dl class="details">
    <dt>Description</dt>
    <dd>{{ data.body }}</dd>

    <dt>Type</dt>
    <dd>{{ data.typeLabel }}</dd>

    @if (data.entityNumber) {
      <dt>Case</dt>
      <dd>{{ data.entityNumber }}</dd>
    }

    <dt>Received</dt>
    <dd>{{ data.createdOn | date: 'MMM d, y, h:mm a' }} · {{ relativeReceived }}</dd>
  </dl>
</div>

<div neoDialogActions class="dialog-actions">
  <cm-button variant="basic" color="primary" size="sm" (click)="onClose()" [autId]="data.autIdPrefix + 'notification-detail-close-btn'">
    Close
  </cm-button>
  @if (data.entityId || data.link) {
    <cm-button variant="flat" color="primary" size="sm" (click)="onOpenEntity()" [autId]="data.autIdPrefix + 'notification-detail-open-btn'">
      Open case
    </cm-button>
  }
</div>
